import { Link } from 'react-router';
import { ApiError } from '../../lib/api.js';
import './infrastructure.css';

export function errMessage(err: unknown, fallback: string): string {
  return err instanceof ApiError ? err.message : fallback;
}

/** Backend returns 409 when no active provider credential is configured. */
export function isProviderNotConfigured(err: unknown): err is ApiError {
  return err instanceof ApiError && err.status === 409;
}

/** Don't retry 4xx responses (409 not-configured, 403, validation errors). */
export function retryUnlessClientError(failureCount: number, error: unknown): boolean {
  if (error instanceof ApiError && error.status >= 400 && error.status < 500) return false;
  return failureCount < 2;
}

export function fmtDate(iso: string | null): string {
  if (!iso) return '—';
  return new Date(iso).toLocaleString(undefined, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

/** "80, 443" / "10.0.0.0/8, 1.2.3.4" → trimmed non-empty entries. */
export function splitCsv(value: string): string[] {
  return value
    .split(',')
    .map((s) => s.trim())
    .filter((s) => s.length > 0);
}

/** Comma-separated numeric ids → numbers (invalid entries return null). */
export function parseIdCsv(value: string): number[] | null {
  const parts = splitCsv(value);
  const ids: number[] = [];
  for (const part of parts) {
    const n = Number(part);
    if (!Number.isInteger(n) || n <= 0) return null;
    ids.push(n);
  }
  return ids;
}

export function ProviderNotConfiguredCard({
  provider,
  message,
}: {
  provider: string;
  message?: string | undefined;
}) {
  return (
    <div className="card provider-empty">
      <h2>{provider} is not connected</h2>
      <p className="provider-empty-msg">
        {message ?? `Add an active ${provider} credential to manage these resources.`}
      </p>
      <Link to="/credentials" className="btn btn-amber">
        Go to credentials
      </Link>
    </div>
  );
}
